import React, {useEffect} from 'react';
import styles from './MainMenu.module.scss'
import InteractionContainer from "../../../partials/InteractionContainer/InteractionContainer";
import Globe from "./Globe/Globe";
import SegmentedSlider from "../SegmentedSlider/SegmentedSlider";
import ContentBox from "../common/ContentBox/ContentBox";
import Button, {ButtonsHolder} from "../../../partials/Button";

import SelectScenario from "./SelectScenario/SelectScenario"
import Header from "../../../partials/Header";
import HTMLContent from "../../../partials/HTMLContent";
import Scroll from "../../../partials/Scroll/Scroll";
function MainMenu(props) {
    const defaultOrbit = props?.defaultOrbit;
    const isLight = props?.light === true
    const [selectedOrbit, setSelectedOrbit] = React.useState("LEO")
    const [currentOrbitObj, setCurrentOrbitObj] = React.useState()
    const orbits = props?.orbits || []
    const sliderValues = orbits.map( o =>  o.header)

    let defaultSelectedIndex
    if (defaultOrbit) {
        const idx = sliderValues.indexOf(defaultOrbit.toUpperCase())
        defaultSelectedIndex =  idx > -1 ? idx : false
        // Select Orbit and Disable Rest.
    }

    useEffect( () => {
        const obj = orbits.find( o =>o.header.toLowerCase() === selectedOrbit.toLowerCase() )
        setCurrentOrbitObj(obj)
        if (props?.onOrbitSelect) {
            props.onOrbitSelect(selectedOrbit)
        }
    }, [selectedOrbit])
    const handleSelectedScenario = (s) => {
        if (props?.onSelectedScenario) {
            props.onSelectedScenario();
        }
    }
    const getFirstNoneCheckedOrbitIndex = () => {
        let firstNoneCheckedIndex = orbits.indexOf( orbits.find(o => o.checked === false) )
        firstNoneCheckedIndex =  firstNoneCheckedIndex > -1  && firstNoneCheckedIndex < orbits.length ? firstNoneCheckedIndex : 0

        return firstNoneCheckedIndex;
    }

    return  <InteractionContainer variant={'starfield'}>
        <div className={styles.MainMenu}>
            <Scroll>
                <div className={styles.Instructions}>
                    <h2 dangerouslySetInnerHTML={{__html: props?.instructions || 'Select and Orbit to explore concepts and aspects'}} />
                </div>
            </Scroll>
            <Globe selected={selectedOrbit} orbits={props.orbits} show={[]} translateX={-380} translateY={-200}>
            </Globe>
            <div className={styles.OrbitPicker}>
                <SegmentedSlider
                    caption={'orbits'}
                    values={sliderValues}
                    onChange={o => setSelectedOrbit(o)}
                    disabled={defaultSelectedIndex > -1}
                    defaultValue={defaultSelectedIndex || getFirstNoneCheckedOrbitIndex() || 0}
                />
            </div>
            {!props?.unlocked  && currentOrbitObj && <div className={`${styles.Content} ${isLight ? styles.light : ''}`} style={{marginTop:"100px"}}>
                <ContentBox title={currentOrbitObj.name}
                            htmlContent={currentOrbitObj.body}
                >
                </ContentBox>
                <div className={styles.ActionButton}>
                    <Button
                        onClick={props?.onStartOrbit ? () => props.onStartOrbit(currentOrbitObj) : () =>{} }
                        text={props?.continueButtonCaption || 'START'}
                    ></Button>
                </div>

            </div>}
            { props?.unlocked === true && props.story && <div className={styles.Content} style={{marginTop:"5px"}}>
                <SelectScenario story={props.story}
                                doSkip={true}
                                onSelected={handleSelectedScenario}
                                onComplete={ () => {
                                    if (props?.onComplete) {
                                        props.onComplete()
                                    }
                                } }
                                doCompleteSegment={props?.enableCompleteButton === true}
                                completeButtonCaption={props?.completeButtonCaption}
                >
                </SelectScenario>

            </div>}




        </div>

    </InteractionContainer>



}

export default MainMenu;


